export const TIME_ZONE_CONSTANTS = {
  // UTC-12
  'Etc/GMT+12': {
    abbreviation: 'BIT',
    fullName: 'Baker Island Time',
    offset: '-12:00',
    shortName: 'GMT-12',
  },

  // UTC-11
  'Pacific/Pago_Pago': {
    abbreviation: 'SST',
    fullName: 'Samoa Standard Time',
    offset: '-11:00',
    shortName: 'Pago Pago',
  },
  'Pacific/Midway': {
    abbreviation: 'SST',
    fullName: 'Samoa Standard Time',
    offset: '-11:00',
    shortName: 'Midway',
  },
  'Pacific/Niue': {
    abbreviation: 'NUT',
    fullName: 'Niue Time',
    offset: '-11:00',
    shortName: 'Niue',
  },

  // UTC-10
  'Pacific/Honolulu': {
    abbreviation: 'HST',
    fullName: 'Hawaii Standard Time',
    offset: '-10:00',
    shortName: 'Honolulu',
  },
  'Pacific/Rarotonga': {
    abbreviation: 'CKT',
    fullName: 'Cook Island Time',
    offset: '-10:00',
    shortName: 'Rarotonga',
  },
  'Pacific/Tahiti': {
    abbreviation: 'TAHT',
    fullName: 'Tahiti Time',
    offset: '-10:00',
    shortName: 'Tahiti',
  },
  'America/Adak': {
    abbreviation: 'HST',
    fullName: 'Hawaii Standard Time',
    offset: '-10:00',
    shortName: 'Adak',
  },

  // UTC-9
  'America/Anchorage': {
    abbreviation: 'AKST',
    fullName: 'Alaska Standard Time',
    offset: '-09:00',
    shortName: 'Anchorage',
  },
  'America/Juneau': {
    abbreviation: 'AKST',
    fullName: 'Alaska Standard Time',
    offset: '-09:00',
    shortName: 'Juneau',
  },

  // UTC-8
  'America/Los_Angeles': {
    abbreviation: 'PST',
    fullName: 'Pacific Standard Time',
    offset: '-08:00',
    shortName: 'Los Angeles',
  },
  'America/Tijuana': {
    abbreviation: 'PST',
    fullName: 'Pacific Standard Time',
    offset: '-08:00',
    shortName: 'Tijuana',
  },
  'America/Vancouver': {
    abbreviation: 'PST',
    fullName: 'Pacific Standard Time',
    offset: '-08:00',
    shortName: 'Vancouver',
  },

  // UTC-7
  'America/Phoenix': {
    abbreviation: 'MST',
    fullName: 'Mountain Standard Time',
    offset: '-07:00',
    shortName: 'Phoenix',
  },
  'America/Denver': {
    abbreviation: 'MST',
    fullName: 'Mountain Standard Time',
    offset: '-07:00',
    shortName: 'Denver',
  },
  'America/Edmonton': {
    abbreviation: 'MST',
    fullName: 'Mountain Standard Time',
    offset: '-07:00',
    shortName: 'Edmonton',
  },
  'America/Mazatlan': {
    abbreviation: 'MST',
    fullName: 'Mountain Standard Time',
    offset: '-07:00',
    shortName: 'Mazatlan',
  },
  'America/Chihuahua': {
    abbreviation: 'MST',
    fullName: 'Mountain Standard Time',
    offset: '-07:00',
    shortName: 'Chihuahua',
  },

  // UTC-6
  'America/Chicago': {
    abbreviation: 'CST',
    fullName: 'Central Standard Time',
    offset: '-06:00',
    shortName: 'Chicago',
  },
  'America/Mexico_City': {
    abbreviation: 'CST',
    fullName: 'Central Standard Time',
    offset: '-06:00',
    shortName: 'Mexico City',
  },
  'America/Guatemala': {
    abbreviation: 'CST',
    fullName: 'Central Standard Time',
    offset: '-06:00',
    shortName: 'Guatemala',
  },
  'America/Monterrey': {
    abbreviation: 'CST',
    fullName: 'Central Standard Time',
    offset: '-06:00',
    shortName: 'Monterrey',
  },
  'America/Regina': {
    abbreviation: 'CST',
    fullName: 'Central Standard Time',
    offset: '-06:00',
    shortName: 'Regina',
  },
  'America/Belize': {
    abbreviation: 'CST',
    fullName: 'Central Standard Time',
    offset: '-06:00',
    shortName: 'Belize',
  },

  // UTC-5
  'America/New_York': {
    abbreviation: 'EST',
    fullName: 'Eastern Standard Time',
    offset: '-05:00',
    shortName: 'New York',
  },
  'America/Toronto': {
    abbreviation: 'EST',
    fullName: 'Eastern Standard Time',
    offset: '-05:00',
    shortName: 'Toronto',
  },
  'America/Indiana/Indianapolis': {
    abbreviation: 'EST',
    fullName: 'Eastern Standard Time',
    offset: '-05:00',
    shortName: 'Indianapolis',
  },
  'America/Fort_Wayne': {
    abbreviation: 'EST',
    fullName: 'Eastern Standard Time',
    offset: '-05:00',
    shortName: 'Indianapolis',
  },
  'America/Lima': {
    abbreviation: 'PET',
    fullName: 'Peru Time',
    offset: '-05:00',
    shortName: 'Lima',
  },
  'America/Bogota': {
    abbreviation: 'COT',
    fullName: 'Colombia Time',
    offset: '-05:00',
    shortName: 'Bogota',
  },
  'America/Jamaica': {
    abbreviation: 'EST',
    fullName: 'Eastern Standard Time',
    offset: '-05:00',
    shortName: 'Jamaica',
  },
  'America/Panama': {
    abbreviation: 'EST',
    fullName: 'Eastern Standard Time',
    offset: '-05:00',
    shortName: 'Panama',
  },

  // UTC-4
  'America/Halifax': {
    abbreviation: 'AST',
    fullName: 'Atlantic Standard Time',
    offset: '-04:00',
    shortName: 'Halifax',
  },
  'America/Puerto_Rico': {
    abbreviation: 'AST',
    fullName: 'Atlantic Standard Time',
    offset: '-04:00',
    shortName: 'Puerto Rico',
  },
  'America/Caracas': {
    abbreviation: 'VET',
    fullName: 'Venezuelan Standard Time',
    offset: '-04:00',
    shortName: 'Caracas',
  },
  'America/Santo_Domingo': {
    abbreviation: 'AST',
    fullName: 'Atlantic Standard Time',
    offset: '-04:00',
    shortName: 'Santo Domingo',
  },
  'America/La_Paz': {
    abbreviation: 'BOT',
    fullName: 'Bolivia Time',
    offset: '-04:00',
    shortName: 'La Paz',
  },
  'America/Guyana': {
    abbreviation: 'GYT',
    fullName: 'Guyana Time',
    offset: '-04:00',
    shortName: 'Guyana',
  },
  'America/Manaus': {
    abbreviation: 'AMT',
    fullName: 'Amazon Time',
    offset: '-04:00',
    shortName: 'Manaus',
  },
  'America/Santiago': {
    abbreviation: 'CLT',
    fullName: 'Chile Standard Time',
    offset: '-04:00',
    shortName: 'Santiago',
  },

  // UTC-3:30
  'America/St_Johns': {
    abbreviation: 'NST',
    fullName: 'Newfoundland Standard Time',
    offset: '-03:30',
    shortName: 'St Johns',
  },

  // UTC-3
  'America/Sao_Paulo': {
    abbreviation: 'BRT',
    fullName: 'Brasilia Time',
    offset: '-03:00',
    shortName: 'Sao Paulo',
  },
  'America/Argentina/Buenos_Aires': {
    abbreviation: 'ART',
    fullName: 'Argentina Time',
    offset: '-03:00',
    shortName: 'Buenos Aires',
  },
  'America/Montevideo': {
    abbreviation: 'UYT',
    fullName: 'Uruguay Standard Time',
    offset: '-03:00',
    shortName: 'Montevideo',
  },
  'America/Recife': {
    abbreviation: 'BRT',
    fullName: 'Brasilia Time',
    offset: '-03:00',
    shortName: 'Recife',
  },

  // UTC-2
  'America/Godthab': {
    abbreviation: 'WGT',
    fullName: 'West Greenland Time',
    offset: '-02:00', // Updated from API (was -03:00)
    shortName: 'Godthab',
  },
  'Atlantic/South_Georgia': {
    abbreviation: 'GST',
    fullName: 'South Georgia Standard Time',
    offset: '-02:00',
    shortName: 'South Georgia',
  },
  'Atlantic/Noronha': {
    abbreviation: 'FNT',
    fullName: 'Fernando de Noronha Time',
    offset: '-02:00',
    shortName: 'Noronha',
  },

  // UTC-1
  'Atlantic/Azores': {
    abbreviation: 'AZOT',
    fullName: 'Azores Standard Time',
    offset: '-01:00',
    shortName: 'Azores',
  },
  'Atlantic/Cape_Verde': {
    abbreviation: 'CVT',
    fullName: 'Cape Verde Time',
    offset: '-01:00',
    shortName: 'Cape Verde',
  },

  // UTC+0
  'Europe/London': {
    abbreviation: 'GMT',
    fullName: 'Greenwich Mean Time',
    offset: '+00:00',
    shortName: 'London',
  },
  'Europe/Dublin': {
    abbreviation: 'GMT',
    fullName: 'Greenwich Mean Time',
    offset: '+00:00',
    shortName: 'Dublin',
  },
  'Europe/Lisbon': {
    abbreviation: 'WET',
    fullName: 'Western European Time',
    offset: '+00:00',
    shortName: 'Lisbon',
  },
  'Africa/Monrovia': {
    abbreviation: 'GMT',
    fullName: 'Greenwich Mean Time',
    offset: '+00:00',
    shortName: 'Monrovia',
  },
  'Etc/UTC': {
    abbreviation: 'UTC',
    fullName: 'Coordinated Universal Time',
    offset: '+00:00',
    shortName: 'UTC',
  },
  'Atlantic/Reykjavik': {
    abbreviation: 'GMT',
    fullName: 'Greenwich Mean Time',
    offset: '+00:00',
    shortName: 'Reykjavik',
  },

  // UTC+1
  'Europe/Amsterdam': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Amsterdam',
  },
  'Europe/Belgrade': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Belgrade',
  },
  'Europe/Berlin': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Berlin',
  },
  'Europe/Zurich': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Zurich',
  },
  'Europe/Bratislava': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Bratislava',
  },
  'Europe/Brussels': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Brussels',
  },
  'Europe/Budapest': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Budapest',
  },
  'Africa/Casablanca': {
    abbreviation: 'WET',
    fullName: 'Western European Time',
    offset: '+01:00', // Updated from API (was +00:00)
    shortName: 'Casablanca',
  },
  'Europe/Copenhagen': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Copenhagen',
  },
  'Europe/Ljubljana': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Ljubljana',
  },
  'Europe/Madrid': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Madrid',
  },
  'Europe/Paris': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Paris',
  },
  'Europe/Prague': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Prague',
  },
  'Europe/Rome': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Rome',
  },
  'Europe/Sarajevo': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Sarajevo',
  },
  'Europe/Skopje': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Skopje',
  },
  'Europe/Stockholm': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Stockholm',
  },
  'Europe/Vienna': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Vienna',
  },
  'Europe/Warsaw': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Warsaw',
  },
  'Africa/Algiers': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Algiers',
  },
  'Europe/Zagreb': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Zagreb',
  },
  'Africa/Tunis': {
    abbreviation: 'CET',
    fullName: 'Central European Time',
    offset: '+01:00',
    shortName: 'Tunis',
  },
  'Africa/Lagos': {
    abbreviation: 'WAT',
    fullName: 'West Africa Time',
    offset: '+01:00',
    shortName: 'Lagos',
  },

  // UTC+2
  'Europe/Athens': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Athens',
  },
  'Europe/Bucharest': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Bucharest',
  },
  'Africa/Cairo': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Cairo',
  },
  'Africa/Harare': {
    abbreviation: 'CAT',
    fullName: 'Central Africa Time',
    offset: '+02:00',
    shortName: 'Harare',
  },
  'Africa/Maputo': {
    abbreviation: 'CAT',
    fullName: 'Central Africa Time',
    offset: '+02:00',
    shortName: 'Maputo',
  },
  'Europe/Helsinki': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Helsinki',
  },
  'Asia/Jerusalem': {
    abbreviation: 'IST',
    fullName: 'Israel Standard Time',
    offset: '+02:00',
    shortName: 'Jerusalem',
  },
  'Europe/Kaliningrad': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Kaliningrad',
  },
  'Europe/Kiev': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Kiev',
  },
  'Africa/Johannesburg': {
    abbreviation: 'SAST',
    fullName: 'South Africa Standard Time',
    offset: '+02:00',
    shortName: 'Johannesburg',
  },
  'Europe/Riga': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Riga',
  },
  'Europe/Sofia': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Sofia',
  },
  'Europe/Tallinn': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Tallinn',
  },
  'Europe/Vilnius': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Vilnius',
  },
  'Africa/Windhoek': {
    abbreviation: 'CAT',
    fullName: 'Central Africa Time',
    offset: '+02:00',
    shortName: 'Windhoek',
  },
  'Asia/Beirut': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Beirut',
  },
  'Asia/Damascus': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Damascus',
  },
  'Asia/Amman': {
    abbreviation: 'EET',
    fullName: 'Eastern European Time',
    offset: '+02:00',
    shortName: 'Amman',
  },

  // UTC+3
  'Asia/Baghdad': {
    abbreviation: 'AST',
    fullName: 'Arabia Standard Time',
    offset: '+03:00',
    shortName: 'Baghdad',
  },
  'Europe/Istanbul': {
    abbreviation: 'TRT',
    fullName: 'Turkey Time',
    offset: '+03:00',
    shortName: 'Istanbul',
  },
  'Asia/Kuwait': {
    abbreviation: 'AST',
    fullName: 'Arabia Standard Time',
    offset: '+03:00',
    shortName: 'Kuwait',
  },
  'Europe/Minsk': {
    abbreviation: 'MSK',
    fullName: 'Moscow Standard Time',
    offset: '+03:00',
    shortName: 'Minsk',
  },
  'Europe/Moscow': {
    abbreviation: 'MSK',
    fullName: 'Moscow Standard Time',
    offset: '+03:00',
    shortName: 'Moscow',
  },
  'Africa/Nairobi': {
    abbreviation: 'EAT',
    fullName: 'East Africa Time',
    offset: '+03:00',
    shortName: 'Nairobi',
  },
  'Asia/Riyadh': {
    abbreviation: 'AST',
    fullName: 'Arabia Standard Time',
    offset: '+03:00',
    shortName: 'Riyadh',
  },
  'Europe/Volgograd': {
    abbreviation: 'MSK',
    fullName: 'Moscow Standard Time',
    offset: '+03:00',
    shortName: 'Volgograd',
  },
  'Asia/Qatar': {
    abbreviation: 'AST',
    fullName: 'Arabia Standard Time',
    offset: '+03:00',
    shortName: 'Qatar',
  },
  'Asia/Aden': {
    abbreviation: 'AST',
    fullName: 'Arabia Standard Time',
    offset: '+03:00',
    shortName: 'Aden',
  },

  // UTC+3:30
  'Asia/Tehran': {
    abbreviation: 'IRST',
    fullName: 'Iran Standard Time',
    offset: '+03:30',
    shortName: 'Tehran',
  },

  // UTC+4
  'Asia/Muscat': {
    abbreviation: 'GST',
    fullName: 'Gulf Standard Time',
    offset: '+04:00',
    shortName: 'Muscat',
  },
  'Asia/Baku': {
    abbreviation: 'AZT',
    fullName: 'Azerbaijan Time',
    offset: '+04:00',
    shortName: 'Baku',
  },
  'Europe/Samara': {
    abbreviation: 'SAMT',
    fullName: 'Samara Time',
    offset: '+04:00',
    shortName: 'Samara',
  },
  'Asia/Tbilisi': {
    abbreviation: 'GET',
    fullName: 'Georgia Standard Time',
    offset: '+04:00',
    shortName: 'Tbilisi',
  },
  'Asia/Yerevan': {
    abbreviation: 'AMT',
    fullName: 'Armenia Time',
    offset: '+04:00',
    shortName: 'Yerevan',
  },
  'Asia/Dubai': {
    abbreviation: 'GST',
    fullName: 'Gulf Standard Time',
    offset: '+04:00',
    shortName: 'Dubai',
  },
  'Indian/Mauritius': {
    abbreviation: 'MUT',
    fullName: 'Mauritius Time',
    offset: '+04:00',
    shortName: 'Mauritius',
  },
  'Indian/Reunion': {
    abbreviation: 'RET',
    fullName: 'Reunion Time',
    offset: '+04:00',
    shortName: 'Reunion',
  },

  // UTC+4:30
  'Asia/Kabul': {
    abbreviation: 'AFT',
    fullName: 'Afghanistan Time',
    offset: '+04:30',
    shortName: 'Kabul',
  },

  // UTC+5
  'Asia/Almaty': {
    abbreviation: 'ALMT',
    fullName: 'Alma-Ata Time',
    offset: '+05:00',
    shortName: 'Almaty',
  },
  'Asia/Yekaterinburg': {
    abbreviation: 'YEKT',
    fullName: 'Yekaterinburg Time',
    offset: '+05:00',
    shortName: 'Yekaterinburg',
  },
  'Asia/Karachi': {
    abbreviation: 'PKT',
    fullName: 'Pakistan Standard Time',
    offset: '+05:00',
    shortName: 'Karachi',
  },
  'Asia/Tashkent': {
    abbreviation: 'UZT',
    fullName: 'Uzbekistan Time',
    offset: '+05:00',
    shortName: 'Tashkent',
  },
  'Asia/Ashgabat': {
    abbreviation: 'TMT',
    fullName: 'Turkmenistan Time',
    offset: '+05:00',
    shortName: 'Ashgabat',
  },
  'Asia/Dushanbe': {
    abbreviation: 'TJT',
    fullName: 'Tajikistan Time',
    offset: '+05:00',
    shortName: 'Dushanbe',
  },
  'Indian/Maldives': {
    abbreviation: 'MVT',
    fullName: 'Maldives Time',
    offset: '+05:00',
    shortName: 'Maldives',
  },

  // UTC+5:30
  'Asia/Kolkata': {
    abbreviation: 'IST',
    fullName: 'Indian Standard Time',
    offset: '+05:30',
    shortName: 'Kolkata',
  },
  'Asia/Colombo': {
    abbreviation: 'IST',
    fullName: 'Indian Standard Time',
    offset: '+05:30',
    shortName: 'Colombo',
  },

  // UTC+5:45
  'Asia/Kathmandu': {
    abbreviation: 'NPT',
    fullName: 'Nepal Time',
    offset: '+05:45',
    shortName: 'Kathmandu',
  },

  // UTC+6
  'Asia/Dhaka': {
    abbreviation: 'BST',
    fullName: 'Bangladesh Standard Time',
    offset: '+06:00',
    shortName: 'Dhaka',
  },
  'Asia/Urumqi': {
    abbreviation: 'CST',
    fullName: 'China Standard Time',
    offset: '+06:00',
    shortName: 'Urumqi',
  },
  'Asia/Bishkek': {
    abbreviation: 'KGT',
    fullName: 'Kyrgyzstan Time',
    offset: '+06:00',
    shortName: 'Bishkek',
  },
  'Asia/Omsk': {
    abbreviation: 'OMST',
    fullName: 'Omsk Time',
    offset: '+06:00',
    shortName: 'Omsk',
  },
  'Asia/Thimphu': {
    abbreviation: 'BTT',
    fullName: 'Bhutan Time',
    offset: '+06:00',
    shortName: 'Thimphu',
  },
  'Indian/Chagos': {
    abbreviation: 'IOT',
    fullName: 'Indian Ocean Time',
    offset: '+06:00',
    shortName: 'Chagos',
  },

  // UTC+6:30
  'Asia/Yangon': {
    abbreviation: 'MMT',
    fullName: 'Myanmar Time',
    offset: '+06:30',
    shortName: 'Yangon',
  },
  'Asia/Rangoon': {
    abbreviation: 'MMT',
    fullName: 'Myanmar Time',
    offset: '+06:30',
    shortName: 'Rangoon',
  },

  // UTC+7
  'Asia/Bangkok': {
    abbreviation: 'ICT',
    fullName: 'Indochina Time',
    offset: '+07:00',
    shortName: 'Bangkok',
  },
  'Asia/Jakarta': {
    abbreviation: 'WIB',
    fullName: 'Western Indonesian Time',
    offset: '+07:00',
    shortName: 'Jakarta',
  },
  'Asia/Hovd': {
    abbreviation: 'HOVT',
    fullName: 'Hovd Time',
    offset: '+07:00',
    shortName: 'Hovd',
  },
  'Asia/Ho_Chi_Minh': {
    abbreviation: 'ICT',
    fullName: 'Indochina Time',
    offset: '+07:00',
    shortName: 'Ho Chi Minh',
  },
  'Asia/Novosibirsk': {
    abbreviation: 'NOVT',
    fullName: 'Novosibirsk Time',
    offset: '+07:00',
    shortName: 'Novosibirsk',
  },
  'Asia/Krasnoyarsk': {
    abbreviation: 'KRAT',
    fullName: 'Krasnoyarsk Time',
    offset: '+07:00',
    shortName: 'Krasnoyarsk',
  },
  'Indian/Christmas': {
    abbreviation: 'CXT',
    fullName: 'Christmas Island Time',
    offset: '+07:00',
    shortName: 'Christmas',
  },

  // UTC+8
  'Asia/Shanghai': {
    abbreviation: 'CST',
    fullName: 'China Standard Time',
    offset: '+08:00',
    shortName: 'Shanghai',
  },
  'Asia/Chongqing': {
    abbreviation: 'CST',
    fullName: 'China Standard Time',
    offset: '+08:00',
    shortName: 'Chongqing',
  },
  'Asia/Hong_Kong': {
    abbreviation: 'HKT',
    fullName: 'Hong Kong Time',
    offset: '+08:00',
    shortName: 'Hong Kong',
  },
  'Asia/Irkutsk': {
    abbreviation: 'IRKT',
    fullName: 'Irkutsk Time',
    offset: '+08:00',
    shortName: 'Irkutsk',
  },
  'Asia/Kuala_Lumpur': {
    abbreviation: 'MYT',
    fullName: 'Malaysia Time',
    offset: '+08:00',
    shortName: 'Kuala Lumpur',
  },
  'Australia/Perth': {
    abbreviation: 'AWST',
    fullName: 'Australian Western Standard Time',
    offset: '+08:00',
    shortName: 'Perth',
  },
  'Asia/Singapore': {
    abbreviation: 'SGT',
    fullName: 'Singapore Time',
    offset: '+08:00',
    shortName: 'Singapore',
  },
  'Asia/Taipei': {
    abbreviation: 'CST',
    fullName: 'China Standard Time',
    offset: '+08:00',
    shortName: 'Taipei',
  },
  'Asia/Ulaanbaatar': {
    abbreviation: 'ULAT',
    fullName: 'Ulaanbaatar Time',
    offset: '+08:00',
    shortName: 'Ulaanbaatar',
  },
  'Asia/Makassar': {
    abbreviation: 'WITA',
    fullName: 'Central Indonesian Time',
    offset: '+08:00',
    shortName: 'Makassar',
  },
  'Asia/Manila': {
    abbreviation: 'PHT',
    fullName: 'Philippine Time',
    offset: '+08:00',
    shortName: 'Manila',
  },
  'Asia/Brunei': {
    abbreviation: 'BNT',
    fullName: 'Brunei Time',
    offset: '+08:00',
    shortName: 'Brunei',
  },
  'Asia/Macau': {
    abbreviation: 'CST',
    fullName: 'China Standard Time',
    offset: '+08:00',
    shortName: 'Macau',
  },

  // UTC+9
  'Asia/Tokyo': {
    abbreviation: 'JST',
    fullName: 'Japan Standard Time',
    offset: '+09:00',
    shortName: 'Tokyo',
  },
  'Asia/Seoul': {
    abbreviation: 'KST',
    fullName: 'Korea Standard Time',
    offset: '+09:00',
    shortName: 'Seoul',
  },
  'Asia/Yakutsk': {
    abbreviation: 'YAKT',
    fullName: 'Yakutsk Time',
    offset: '+09:00',
    shortName: 'Yakutsk',
  },
  'Asia/Pyongyang': {
    abbreviation: 'KST',
    fullName: 'Korea Standard Time',
    offset: '+09:00',
    shortName: 'Pyongyang',
  },
  'Asia/Dili': {
    abbreviation: 'TLT',
    fullName: 'Timor Leste Time',
    offset: '+09:00',
    shortName: 'Dili',
  },
  'Asia/Jayapura': {
    abbreviation: 'WIT',
    fullName: 'Eastern Indonesian Time',
    offset: '+09:00',
    shortName: 'Jayapura',
  },
  'Pacific/Palau': {
    abbreviation: 'PWT',
    fullName: 'Palau Time',
    offset: '+09:00',
    shortName: 'Palau',
  },

  // UTC+9:30
  'Australia/Adelaide': {
    abbreviation: 'ACST',
    fullName: 'Australian Central Standard Time',
    offset: '+09:30',
    shortName: 'Adelaide',
  },
  'Australia/Darwin': {
    abbreviation: 'ACST',
    fullName: 'Australian Central Standard Time',
    offset: '+09:30',
    shortName: 'Darwin',
  },

  // UTC+10
  'Australia/Brisbane': {
    abbreviation: 'AEST',
    fullName: 'Australian Eastern Standard Time',
    offset: '+10:00',
    shortName: 'Brisbane',
  },
  'Australia/Melbourne': {
    abbreviation: 'AEST',
    fullName: 'Australian Eastern Standard Time',
    offset: '+10:00',
    shortName: 'Melbourne',
  },
  'Pacific/Guam': {
    abbreviation: 'ChST',
    fullName: 'Chamorro Standard Time',
    offset: '+10:00',
    shortName: 'Guam',
  },
  'Australia/Hobart': {
    abbreviation: 'AEST',
    fullName: 'Australian Eastern Standard Time',
    offset: '+10:00',
    shortName: 'Hobart',
  },
  'Pacific/Port_Moresby': {
    abbreviation: 'PGT',
    fullName: 'Papua New Guinea Time',
    offset: '+10:00',
    shortName: 'Port Moresby',
  },
  'Australia/Sydney': {
    abbreviation: 'AEST',
    fullName: 'Australian Eastern Standard Time',
    offset: '+10:00',
    shortName: 'Sydney',
  },
  'Asia/Vladivostok': {
    abbreviation: 'VLAT',
    fullName: 'Vladivostok Time',
    offset: '+10:00',
    shortName: 'Vladivostok',
  },
  'Pacific/Chuuk': {
    abbreviation: 'CHUT',
    fullName: 'Chuuk Time',
    offset: '+10:00',
    shortName: 'Chuuk',
  },

  // UTC+11
  'Asia/Magadan': {
    abbreviation: 'MAGT',
    fullName: 'Magadan Time',
    offset: '+11:00',
    shortName: 'Magadan',
  },
  'Pacific/Noumea': {
    abbreviation: 'NCT',
    fullName: 'New Caledonia Time',
    offset: '+11:00',
    shortName: 'Noumea',
  },
  'Pacific/Guadalcanal': {
    abbreviation: 'SBT',
    fullName: 'Solomon Islands Time',
    offset: '+11:00',
    shortName: 'Guadalcanal',
  },
  'Asia/Srednekolymsk': {
    abbreviation: 'SRET',
    fullName: 'Srednekolymsk Time',
    offset: '+11:00',
    shortName: 'Srednekolymsk',
  },
  'Pacific/Kosrae': {
    abbreviation: 'KOST',
    fullName: 'Kosrae Time',
    offset: '+11:00',
    shortName: 'Kosrae',
  },
  'Pacific/Norfolk': {
    abbreviation: 'NFT',
    fullName: 'Norfolk Time',
    offset: '+11:00',
    shortName: 'Norfolk',
  },

  // UTC+12
  'Pacific/Auckland': {
    abbreviation: 'NZST',
    fullName: 'New Zealand Standard Time',
    offset: '+12:00',
    shortName: 'Auckland',
  },
  'Pacific/Fiji': {
    abbreviation: 'FJT',
    fullName: 'Fiji Time',
    offset: '+12:00',
    shortName: 'Fiji',
  },
  'Asia/Kamchatka': {
    abbreviation: 'PETT',
    fullName: 'Kamchatka Time',
    offset: '+12:00',
    shortName: 'Kamchatka',
  },
  'Pacific/Majuro': {
    abbreviation: 'MHT',
    fullName: 'Marshall Islands Time',
    offset: '+12:00',
    shortName: 'Majuro',
  },
  'Pacific/Nauru': {
    abbreviation: 'NRT',
    fullName: 'Nauru Time',
    offset: '+12:00',
    shortName: 'Nauru',
  },
  'Pacific/Tarawa': {
    abbreviation: 'GILT',
    fullName: 'Gilbert Island Time',
    offset: '+12:00',
    shortName: 'Tarawa',
  },
  'Pacific/Wake': {
    abbreviation: 'WAKT',
    fullName: 'Wake Island Time',
    offset: '+12:00',
    shortName: 'Wake',
  },
  'Pacific/Wallis': {
    abbreviation: 'WFT',
    fullName: 'Wallis & Futuna Time',
    offset: '+12:00',
    shortName: 'Wallis',
  },

  // UTC+12:45
  'Pacific/Chatham': {
    abbreviation: 'CHAST',
    fullName: 'Chatham Standard Time',
    offset: '+12:45',
    shortName: 'Chatham',
  },

  // UTC+13
  'Pacific/Tongatapu': {
    abbreviation: 'TOT',
    fullName: 'Tonga Time',
    offset: '+13:00',
    shortName: 'Tongatapu',
  },
  'Pacific/Apia': {
    abbreviation: 'WST',
    fullName: 'West Samoa Time',
    offset: '+13:00',
    shortName: 'Apia',
  },
  'Pacific/Fakaofo': {
    abbreviation: 'TKT',
    fullName: 'Tokelau Time',
    offset: '+13:00',
    shortName: 'Fakaofo',
  },
  'Pacific/Enderbury': {
    abbreviation: 'PHOT',
    fullName: 'Phoenix Island Time',
    offset: '+13:00',
    shortName: 'Enderbury',
  },

  // UTC+14
  'Pacific/Kiritimati': {
    abbreviation: 'LINT',
    fullName: 'Line Islands Time',
    offset: '+14:00',
    shortName: 'Kiritimati',
  },
};
